export default "__VITE_ASSET__B0lg7sQa__"